import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { DiscussionEditorComponent } from '@farris/discussion-group';
import { ComponentRef } from "./component-ref";

@Directive({
  selector: '[discussionEditorRef]'
})
export class DiscussionEditorComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: DiscussionEditorComponent, public elementRef: ElementRef, public frameContext: FrameContext) { 
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }

}